import React from 'react';
import {Radio,Modal,Input,Form} from 'antd';
import styles from './SDKLivenessForm.module.less';
const FormItem = Form.Item;

const Actions = [
    {value:4,label:'nod'},
    {value:3,label:'shake head'},
    {value:1,label:'blink'},
    {value:2,label:'open mouth'}
];

// props: action，tips

class ItemAction extends React.Component {

    state = {
        isShowTextModal:false
    }

    onRadioChange = (event)=>{
        const target = event.target;
        const textNew = target.text;
        this.props.onChange({
            action:target.value,
            tips:'please '+textNew
        });
    }


    onCloseTextModal = ()=>{
        // 如果关闭，清理已输入内容
        this.setState({
            isShowTextModal:false
        });

    }

    onSaveText = ()=>{
        this.props.form.validateFields((errors, values)=>{
            if(!errors){
                const {value} = this.props;
                value.tips = values.text;
                this.props.onChange(value);
                this.setState({isShowTextModal:false});
            }
        });
    }

    onTipsChange = ()=>{
        this.setState({
            isShowTextModal:true
        },()=>{
            this.props.form.setFieldsValue({text:this.props.value.tips});
        });
    }


    render(){
        const {value = {}} = this.props;
        const {getFieldDecorator} = this.props.form;
        const {action,tips} = value;
        const {isShowTextModal} = this.state;
        return (
            <div>
                <Radio.Group
                    disabled={this.props.disabled}
                    onChange={this.onRadioChange}
                    value={action}
                >
                    {Actions.map(item=>{
                        return <Radio key={item.value} value={item.value} text={item.label}>{item.label}</Radio>;
                    })}
                </Radio.Group>
                <div className={styles.tipsTextBg}>
                    <div className={styles.tipsTextTop}>
                        <img src={require('image/scene/icon/notice.svg')} /><span>Action stage guide copy</span>
                        {!this.props.disabled && <a onClick={this.onTipsChange}>Revise</a>}
                    </div>
                    <div className={styles.tipsText}>{tips}</div>
                </div>
                <Modal
                    visible={isShowTextModal}
                    title="Action stage guide copy"
                    onCancel={this.onCloseTextModal}
                    onOk={this.onSaveText}
                >

                    <FormItem>
                        {getFieldDecorator('text',{
                            rules:[
                                {required:true,message:'not nullable'},
                                {max:100,message:'Cannot be greater than 100 characters'}
                            ]
                        })(
                            <Input
                                placeholder={this.props.placeholder}
                                size="large"
                            />
                        )}
                    </FormItem>

                </Modal>
            </div>
        );
    }

}
export default Form.create()(ItemAction);



// WEBPACK FOOTER //
// ./src/pages/SDKLiveness/ItemAction.js